import React from 'react';

const MeusDadosIco = () => {
  return (
    <svg width="1.5rem" height="1.5rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 396.7 490">
      <path class="st0" d="M303.3,105c0,58-47,105-105,105s-105-47-105-105s47-105,105-105S303.3,47,303.3,105" />
      <path class="st0" d="M373.3,490c12.9,0,23.3-10.4,23.3-23.3v-35c0-109.5-88.8-198.3-198.3-198.3S0,322.1,0,431.7v35
	C0,479.6,10.4,490,23.3,490H373.3z"/>
    </svg>

  )
}

export default MeusDadosIco;